module.exports = __webpack_public_path__ + "static/media/tip_with_blue_bg.419e6693.svg";